// counter.actions.ts
import { Action } from '@ngrx/store';
import { User } from '../models/user';

export const LOGIN = '[User] FETCH';
export const LOGIN_SUCCESS = '[User] FETCH_SUCCESS';
export const LOGOUT_SUCCESS = '[User] LOGOUT_SUCCESS';
export const LOGIN_FAILURE = '[User] RESET';
export const SAVE_FLEX = '[User] SAVE_FLEX';
export const TOGGLE_FLEX = '[User] TOGGLE_FLEX';
export const SAVE_FLEX_SUCCESS = '[User] SAVE_FLEX_SUCCESS';
export const SAVE_FLEX_FAILURE = '[User] SAVE_FLEX_FAILURE';

//Filters
export const FETCH_FILTERS = '[User] FETCH_FILTERS';
export const FETCH_FILTERS_SUCCESS = '[User] FETCH_FILTERS_SUCCESS';
export const FETCH_FILTERS_FAILURE = '[User] FETCH_FILTERS_FAILURE';

export const CREATE_FILTER = '[User] CREATE_FILTER';
export const CREATE_FILTER_SUCCESS = '[User] CREATE_FILTER_SUCCESS';
export const CREATE_FILTER_FAILURE = '[User] CREATE_FILTER_FAILURE';

export const DELETE_FILTER = '[User] DELETE_FILTER';
export const DELETE_FILTER_SUCCESS = '[User] DELETE_FILTER_SUCCESS';
export const DELETE_FILTER_FAILURE = '[User] DELETE_FILTER_FAILURE';

export const UPDATE_FILTER = '[User] UPDATE_FILTER';
export const UPDATE_FILTER_SUCCESS = '[User] UPDATE_FILTER_SUCCESS';
export const UPDATE_FILTER_FAILURE = '[User] UPDATE_FILTER_FAILURE';

export const ADD_STOCK_TO_FILTER = '[User] ADD_STOCK_TO_FILTER';
export const ADD_STOCK_TO_FILTER_SUCCESS = '[User] ADD_STOCK_TO_FILTER_SUCCESS';
export const ADD_STOCK_TO_FILTER_FAILURE = '[User] ADD_STOCK_TO_FILTER_FAILURE';
export const REMOVE_STOCK_FROM_FILTER = '[User] REMOVE_STOCK_FROM_FILTER';
export const REMOVE_STOCK_FROM_FILTER_SUCCESS = '[User] REMOVE_STOCK_FROM_FILTERSUCCESS';
export const REMOVE_STOCK_FROM_FILTER_FAILURE = '[User] REMOVE_STOCK_FROM_FILTERFAILURE';


export class Login implements Action {
  readonly type = LOGIN;
  constructor(public payload: string) { }
}

export class FetchFilters implements Action {
  readonly type = FETCH_FILTERS;
  constructor(public payload: string) { }
}

export class FetchFiltersSuccess implements Action {
  readonly type = FETCH_FILTERS_SUCCESS;
  constructor(public payload: any) { }
}

export class FetchFiltersFailure implements Action {
  readonly type = FETCH_FILTERS_FAILURE;
  constructor(public payload: any) { }
}

export class CreateFilter implements Action {
  readonly type = CREATE_FILTER;
  constructor(public payload: any) { }
}

export class CreateFilterSuccess implements Action {
  readonly type = CREATE_FILTER_SUCCESS;
  constructor(public payload: any) { }
}

export class CreateFilterFailure implements Action {
  readonly type = CREATE_FILTER_FAILURE;
  constructor(public payload: string) { }
}

export class UpdateFilter implements Action {
  readonly type = UPDATE_FILTER;
  constructor(public payload: any) { }
}

export class UpdateFilterSuccess implements Action {
  readonly type = UPDATE_FILTER_SUCCESS;
  constructor(public payload: any) { }
}

export class UpdateFilterFailure implements Action {
  readonly type = UPDATE_FILTER_FAILURE;
  constructor(public payload: string) { }
}

export class DeleteFilter implements Action {
  readonly type = DELETE_FILTER;
  constructor(public payload: any) { }
}

export class DeleteFilterSuccess implements Action {
  readonly type = DELETE_FILTER_SUCCESS;
  constructor(public payload: any) { }
}

export class DeleteFilterFailure implements Action {
  readonly type = DELETE_FILTER_FAILURE;
  constructor(public payload: any) { }
}

export class LogoutSuccess implements Action {
  readonly type = LOGOUT_SUCCESS;
  constructor() { }
}

export class LoginSuccess implements Action {
  readonly type = LOGIN_SUCCESS;
  constructor(public payload: User) { }
}

export class LoginFailure implements Action {
  readonly type = LOGIN_FAILURE;
  constructor(public payload: any) { }
}

export class SaveFlex implements Action {
  readonly type = SAVE_FLEX;
  constructor(public payload: any) { }
}

export class ToggleFlex implements Action {
  readonly type = TOGGLE_FLEX;
  constructor(public payload: any) { }
}

export class SaveFlexSuccess implements Action {
  readonly type = SAVE_FLEX_SUCCESS;
  constructor(public payload: User) { }
}

export class SaveFlexFailure implements Action {
  readonly type = SAVE_FLEX_FAILURE;
  constructor(public payload: User) { }
}

export class AddStockToFilter implements Action {
  readonly type = ADD_STOCK_TO_FILTER;
  constructor(public payload: any) { }
}
export class AddStockToFilterSuccess implements Action {
  readonly type = ADD_STOCK_TO_FILTER_SUCCESS;
  constructor(public payload: any) { }
}
export class AddStockToFilterFailure implements Action {
  readonly type = ADD_STOCK_TO_FILTER_FAILURE;
  constructor(public payload: any) { }
}

export class RemoveStockFromFilter implements Action {
  readonly type = REMOVE_STOCK_FROM_FILTER;
  constructor(public payload: any) { }
}
export class RemoveStockFromFilterSuccess implements Action {
  readonly type = REMOVE_STOCK_FROM_FILTER_SUCCESS;
  constructor(public payload: any) { }
}
export class RemoveStockFromFilterFailure implements Action {
  readonly type = REMOVE_STOCK_FROM_FILTER_FAILURE;
  constructor(public payload: any) { }
}

export type Actions = Login | LoginSuccess | LoginFailure | LogoutSuccess
  | SaveFlex | SaveFlexSuccess | SaveFlexFailure | ToggleFlex
  | FetchFilters | FetchFiltersSuccess | FetchFiltersFailure
  | CreateFilter | CreateFilterSuccess | CreateFilterFailure
  | DeleteFilter | DeleteFilterSuccess | DeleteFilterFailure
  | UpdateFilter | UpdateFilterSuccess | UpdateFilterFailure
  | AddStockToFilter | RemoveStockFromFilter
  | AddStockToFilterSuccess | RemoveStockFromFilterSuccess
  | AddStockToFilterFailure | RemoveStockFromFilterFailure;



// WEBPACK FOOTER //
// ./src/actions/user.actions.ts